export default __webpack_public_path__ + "static/media/executiveReponse.6fab3608.gif";